import { getCache, setCache } from '@/utils/cache'
import { AttendanceLimitResponse } from '@/modules/MedicalSpecialities/types'
interface Props {
  attendanceType: string
  push: (url) => void
  hasPayment: boolean
  hasMultipleCards?: boolean
}

export const redirectToCheckout = async ({
  attendanceType,
  push,
  hasPayment,
  hasMultipleCards,
}: Props): Promise<void> => {
  setCache('attendanceType', attendanceType)
  const hasFreeAttendance: AttendanceLimitResponse = getCache(
    'has-free-attendance',
  )

  if (!hasPayment) {
    try {
      hasMultipleCards
        ? push('/checkout/carteirinha')
        : push('/checkout/confirmar')
    } catch (err) {
      throw new Error(err)
    }
    return
  }
  if (hasPayment && hasFreeAttendance === 'limitNotReached') {
    push('/checkout/confirmar')
    return
  }
  push('/checkout/tipo-de-pagamento')
}

export const getCheckoutRedirectUrl = ({
  attendanceType,
  hasPayment,
  hasMultipleCards,
}: Omit<Props, 'push'>): string => {
  setCache('attendanceType', attendanceType)
  const hasFreeAttendance: AttendanceLimitResponse = getCache(
    'has-free-attendance',
  )

  if (!hasPayment) {
    return hasMultipleCards ? '/checkout/carteirinha' : '/checkout/confirmar'
  }

  if (hasPayment && hasFreeAttendance === 'limitNotReached') {
    return '/checkout/confirmar'
  }

  return '/checkout/tipo-de-pagamento'
}
